<template>
  <v-chip
    :class="chipClass"
    :text-color="textColor"
    :color="color"
    :x-small="xSmall"
    :small="small"
    v-bind="$attrs"
  >
    <v-icon
      class="mr-1"
      :color="textColor"
      :small="small || xSmall"
    >
      mdi-currency-usd
    </v-icon>
    {{ name }}
  </v-chip>
</template>

<script>
export default {
  name: "CostChip",
  props: {
    name: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: "blue"
    },
    textColor: {
      type: String,
      default: "white"
    },
    xSmall: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    chipClass: {
      type: String,
      default: "mx-1"
    }
  }
}
</script>
